
<b-list-group flush class="my-n3">
  <slot/>
</b-list-group>
